export default __webpack_public_path__ + "static/media/notification.e2e956ce.mp3";